import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class PressReleases extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background press-releases-page">
                    <Banner heading="Press Releases" />
                    <BackButton href={hyperlinks["aboutUs"]} text="❮ About" />
                    <Row className="content">
                        <Col md={12}>
                            {this.props.pressReleases.map(e => (
                                <div key={e.id} className="press-release">
                                    <Row>
                                        <Col lg={4} className="banner">
                                            <img src={e.bannerUrl} className="img-responsive" />
                                        </Col>
                                        <Col lg={8} className="content-and-learn-more">
                                            <h2>{e.title}</h2>
                                            <p>{e.formattedDate}</p>
                                            <Col lg={3} lgOffset={9} className="text-right learn-more-wrapper">
                                                <BackButton href={e.url} text="Learn more" />
                                            </Col>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/PressReleases.jsx.erb